import { onMounted, onUnmounted } from 'vue'
import type { WalletInteractionHooks } from './contracts'
import { getWalletBindings } from './controller'

export const useWalletBindings = (hooks: WalletInteractionHooks): void => {
  const owner = getWalletBindings()
  onMounted(() => {
    owner.wire(hooks)
  })
  onUnmounted(() => {
    owner.dispose()
  })
}
